import type { Reply } from 'models';
import { Button, Col, Comment2LineIcon, Row } from 'ui';
import { useCommentLikeObjectMutation, useCommentUnlikeObjectMutation } from 'features/like';
import { CommentAge } from './comment-age';
import { LikeButton } from './like-button';

type P = {
  comment: Reply;
  contentObjectId: string;
  onReplyClick?: () => void;
};

const CommentFooter = ({ comment, contentObjectId, onReplyClick }: P) => {
  const { isPending: isLiking, mutate: likeObject } = useCommentLikeObjectMutation();
  const { isPending: isUnliking, mutate: unlikeObject } = useCommentUnlikeObjectMutation();

  const handleLike = () => {
    comment.liked
      ? unlikeObject({
          contentObjectId,
          id: comment.id,
        })
      : likeObject({
          contentObjectId,
          id: comment.id,
        });
  };

  return (
    <Row className="comment-footer" justify="space-between">
      <Col>
        <Row gutter={['ms', 0]}>
          <Col>
            <CommentAge createdAt={comment.createdAt} />
          </Col>
          <Col>
            <LikeButton
              count={comment.likesCount}
              isLiked={comment.liked}
              isLoading={isLiking || isUnliking}
              onClickLike={handleLike}
            />
          </Col>
          {onReplyClick ? (
            <Col>
              <Button icon={<Comment2LineIcon />} onClick={onReplyClick} type="link-secondary">
                Reply
              </Button>
            </Col>
          ) : null}
        </Row>
      </Col>
    </Row>
  );
};

export default CommentFooter;
